export enum KeyCode {
    Space = " ",
    Enter = "Enter"
}